<template>
    <!--注册-->
    <div class="register" @keyup="keyUp($event)">
        <ul v-show="!isShow">
            <li class='phone' :class="getPhone">
                <!--<input style="display: none">-->
                <input type="text" v-model.number='registerForm.phone' placeholder="请输入手机号码">
                <span>{{ msgphone }}</span>
            </li>
            <li class='code' :class="getCode">
                <!--<input style="display: none">-->
                <input type="text" autocomplete="off" v-model='registerForm.register_code' placeholder='请输入短信验证码'>
                <span>{{ mesCode }}</span>
                <div @click="getNewCode()" :class="{YiFa:YiFa}">{{ text }}</div>
            </li>
            <li class='pwd' :class="getPwd">
                <!--<input style="display: none">-->
                <input type="text" autocomplete="off" onfocus="this.type='password'" v-model='registerForm.password'
                       placeholder="设置你的登录密码">
                <span>{{ mespass }}</span>
            </li>
        </ul>
        <div class='choose'>
            <div class="checkbox" @click="isAgree()" :class="getClass1"><span :class="getClass2"></span></div>
            <p>
                <span @click="isAgree()"></span>
                <a @click="toLook()">{{ name }}</a>
            </p>
            <span class="message">{{ message }}</span>
        </div>
        <button type='button' :class="getClass" class="btn" @click="submitForm()">同意条款并注册</button>
        <div class="textbox" v-show="isShow">
            <div v-html="userpro"></div>
            <div class="close">
                <i class="iconfont" style="cursor: pointer" @click="closeLarger()">&#xe617;</i>
            </div>
            <div class="closebtn" @click="closeLarger()">关闭</div>
        </div>

    </div>
</template>

<script type="text/ecmascript-6">
	import {getSysTipsList, userRegister, getRegisterCode} from "../../api/index";

	export default {
		data() {
			return {
				selected: true,
				disable: 1,
				phoneChoose: 0,
				registerForm: {
					phone: '',
					register_code: '',
					password: '',
				},
				msgphone: "",
				mesCode: '',
				mespass: '',
				message: '',
				text: "获取验证码",
				ISFS: true, //是否发送  true 默认是可以发送
				YiFa: false,//已发的样式
				name: '',
				userpro: '',
				isShow: false,
			};
		},
		mounted() {
			this.init()
		},
		methods: {
			closeLarger() {
				this.isShow = false
			},
			//获取用户协议
			init() {
				getSysTipsList({}).then(res => {
					console.log(res.data)
					this.name = localStorage.getItem('meta_title') + res.data[0].name
					this.userpro = res.data[0].content

				}).catch(err => {
					console.log(err)
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			toLook() {
				this.isShow = true
			},
			keyUp(event) {
				// console.log(event.keyCode)
				if (event.keyCode === 13) {
					// 调用登录按钮或者登录方法
					this.submitForm()
				}
			},
			// 表单提交
			submitForm() {
				let _this = this;
				let pattern = /^\S{3,12}$/g;
				if (this.registerForm.register_code === '') {
					this.mesCode = '请输入验证码'
				} else if (!this.selected) {
					this.message = '请选择服务协议'
				} else if (this.registerForm.password === '') {
					this.mespass = '请输入密码'
				} else if (!pattern.test(this.registerForm.password)) {
					this.mespass = '请输入3至12位数字密码';
				} else {
					userRegister(
						_this.registerForm
					).then(res => {
						// console.log(res)
						if (res.code === 0) {
							this.$message({
								message: '注册成功',
								type: 'success'
							});
							this.$addStorageEvent("loginSource", 0);
							this.$addStorageEvent("login_type", 0);
							this.$router.push({path: '/login'})
						} else if (res.code === -1) {
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							// this.$router.push({path: './login'})
						}
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						});
					})
				}
			},
			//获取验证码
			getNewCode() {
				let regTel = /^\d{11}$/g;
				if (this.registerForm.phone === '') {
					this.msgphone = "手机号不能为空";
				} else if (!regTel.test(this.registerForm.phone)) {
					// console.log(regTel.test(this.registerForm.phone));
					this.msgphone = ('请输入11位手机号')
				} else if (this.ISFS === true) {
					this.codeTiming();
				} else {
					this.$message({
						message: '请稍后再试',
					});
				}
			},
			// 获取验证码
			codeTiming() {
				let _this = this;
				getRegisterCode({
					phone: this.registerForm.phone
				}).then(result => {
					// console.log(result);
					_this.ISFS = false; //更改为不可以发送
					_this.YiFa = true;//更改为不可选的按钮
					if (result.code === 0) {
						let times = 60;
						let dinshiqi = setInterval(function () {
							times--;
							_this.text = times + "s" + "后重新获取";
							if (times < 1) {
								clearInterval(dinshiqi);
								_this.ISFS = true;
								_this.text = "获取验证码"
								_this.YiFa = false
							}
						}, 1000);
					}
					if (result.code === -1) {
						this.mesCode = result.msg
					}
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					});
				})
			},
			//服务协议的选择
			isAgree() {
				if (this.selected) {
					this.selected = false;
					this.disable = 0
				} else {
					this.selected = true;
					this.disable = 1
				}
			},
		},
		computed: {
			//全填后button样式改变
			getClass() {
				if (this.registerForm.phone === '' || this.registerForm.register_code === '' || this.registerForm.password === '') {
					return
				} else {
					return 'successColor1'
				}
			},
			//内容不为空时去除提示
			getPhone() {
				if (this.registerForm.phone !== '') {
					return this.msgphone = ''
				}
			},
			getCode() {
				if (this.registerForm.register_code !== '') {
					return this.mesCode = ''
				}
			},
			getPwd() {
				if (this.registerForm.password !== '') {
					return this.mespass = ''
				}
			},
			//服务协议选中样式变化
			getClass1() {
				if (this.selected) {
					return 'class1'
				}
			},
			getClass2() {
				if (this.selected) {
					return 'class2'
				}
			}
		}

	}
	;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
    .register {
        padding: 22px 0 60px;
        ul {
            padding-top: 20px;
            li {
                position: relative;
                margin-bottom: 20px;
                input {
                    width: 100%;
                    padding: 10px 0;
                    border: none;
                    border-bottom: 1px solid #ccc;
                    outline: none;
                }

                span {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    font-size: 14px;
                    color: #FF5E5E;
                }

                div {
                    position: absolute;
                    right: 0;
                    bottom: 8px;
                    width: 120px;
                    height: 40px;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    background: #ffae01;
                    border-radius: 2px;
                    cursor: pointer;
                }

                .YiFa {
                    background: #ffae01;
                }
            }
        }
        //服务协议选择框
        .choose {
            position: relative;
            display: flex;
            align-items: center;
            margin: 23px 0;
            .checkbox {
                position: relative;
                display: block;
                width: 14px;
                height: 14px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                border-radius: 50%;
                cursor: pointer;
                span {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 8px;
                    height: 8px;
                    background: transparent;
                    border-radius: 50%;
                }
            }
            .class1 {
                border: 1px solid rgba(255, 174, 1, 1);
                .class2 {
                    background: rgba(255, 174, 1, 1);
                }
            }
            p { ///* 服务协议 */
                font-size: 14px;
                color: rgba(102, 102, 102, 1);
                line-height: 40px;
                margin-left: 10px;
                cursor: pointer;
                span {
                    color: #666;
                }
                a {
                    color: rgba(255, 174, 1, 1);
                }
            }
            .message {
                position: absolute;
                top: 100%;
                font-size: 14px;
                color: #ff5e5e;
            }
        }

        /* 注册按钮 */
        .btn {
            width: 100%;
            height: 52px;
            border: none;
            border-radius: 2px;
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
            line-height: 48px;
            outline: none;
            cursor: pointer;
        }
        .successColor1 {
            background-color: #ffae01;
        }
        .textbox {
            width: 800px;
            height: 700px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            padding: 20px;
            overflow-y: scroll;
            box-sizing: border-box;
            border-radius: 4px;
            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.3);
                i {
                    color: #fff;
                }
            }
            .closebtn {
                width: 200px;
                font-size: 18px;
                color: #fff;
                text-align: center;
                margin-top: 10px;
                padding: 10px;
                line-height: 1;
                background: #f9c851;
            }
        }
    }
</style>